/** Agent debug instrumentation (session 16d74f). WS / /api/client-events への中継のみ。 */
const SESSION_ID = '16d74f';

type DebugTraceSender = (payload: Record<string, unknown>) => void;

let wsTraceSender: DebugTraceSender | null = null;

export function setAgentDebugWsSender(sender: DebugTraceSender | null): void {
  wsTraceSender = sender;
}

export function agentDebugLog(
  hypothesisId: string,
  location: string,
  message: string,
  data: Record<string, unknown> = {},
  runId = 'pre-fix',
): void {
  const payload = {
    sessionId: SESSION_ID,
    runId,
    hypothesisId,
    location,
    message,
    data,
    timestamp: Date.now(),
  };

  // #region agent log
  try {
    wsTraceSender?.(payload);
  } catch {
    // ignore relay failures
  }

  try {
    void fetch('/api/client-events', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: 'agent_debug_trace',
        source: 'interview',
        sessionId: SESSION_ID,
        timestamp: new Date().toISOString(),
        details: {
          hypothesisId,
          location,
          message,
          runId,
          ...data,
        },
      }),
    });
  } catch {
    // ignore relay failures
  }
  // #endregion
}
